import { checkIfFlagIsToggled } from '@famly/vet_ts-utils_local-storage-config';
import { useKinderConnectCaptureRequiredForLeavesQuery } from '@famly/stat_kinder-connect-capture_data';
import { useIsKinderConnectCaptureEnabled } from './use-is-kinder-connect-capture-enabled';
/**
 * Whether KinderConnect TWC capture is required for a leave/absence or holiday-reply covering
 * `childIds` -- true if required for *any* of them (any-of semantics computed server-side).
 * Skips the fetch while `childIds` is empty, and fails closed on a query error.
 */
export const useIsKinderConnectCaptureEnabledForLeaves = (childIds) => {
    var _a;
    const requiredQuery = useKinderConnectCaptureRequiredForLeavesQuery({
        variables: { childIds },
        skip: childIds.length === 0,
    });
    // Fails closed: a leave logged without its capture is unrecoverable, since nothing asks again.
    const captureRequired = requiredQuery.error
        ? true
        : (_a = requiredQuery.data) === null || _a === void 0 ? void 0 : _a.childrenLeaves.kinderConnectCaptureRequired;
    const isEnabled = useIsKinderConnectCaptureEnabled(captureRequired);
    return {
        isEnabled,
        isLoading: requiredQuery.loading && !checkIfFlagIsToggled('KINDER_CONNECT_CAPTURE'),
    };
};
